// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__C-0zL","tableResponsive":"ClientDetail_tableResponsive__4LOEc"};